import PUBLICATIONS from "@/resources/content/publications.json";

export const getPublications = () => {
  return PUBLICATIONS;
};
